<template>
  <div>
    <Form label-position="top" class="pd-r-5 pd-l-5">
      <FormItem label="Сургалт">
        <!-- {{srch.id}}
        {{$store.state.app.mainReportData.propObj}} -->
        <Select v-model="srch.id" filterable clearable class="wd-100p-f">
          <Option
            v-for="(t, i) in filterData.tasks"
            :value="t.id"
            :key="i"
            :label="`${i + 1}.) ${t.task}`"
            >{{ i + 1 }}.) {{ t.task }} ({{
              t.dueStartDate | moment("YYYY.MM.DD")
            }}-{{ t.dueDate | moment("YYYY.MM.DD") }})</Option
          >
        </Select>
      </FormItem>
      <FormItem label="Огноо эхлэх">
        <DatePicker
          type="datetime"
          v-model="srch.startDate"
          :format="'yyyy-MM-dd HH:mm:ss'"
          :value-format="'yyyy-MM-dd HH:mm:ss'"
          placeholder="сонгоно уу"
          class="wd-100p-f"
        ></DatePicker>
      </FormItem>
      <FormItem label="Огноо дууусах">
        <DatePicker
          type="datetime"
          v-model="srch.endDate"
          :format="'yyyy-MM-dd HH:mm:ss'"
          :value-format="'yyyy-MM-dd HH:mm:ss'"
          placeholder="сонгоно уу"
          class="wd-100p-f"
        ></DatePicker>
      </FormItem>
    </Form>
    <hr class="m-t-sm m-b-sm" />
    <div class="pd-l-5 pd-r-5">
      <Button
        @click="$emit('on-seach', srch)"
        icon="md-refresh"
        long
        type="primary"
        >Ачааллах</Button
      >
    </div>
  </div>
</template>

<script>
var _ = require("lodash");
import { request } from "@/api/all";
import { mapActions } from "vuex";
import "element-ui/lib/theme-chalk/index.css";
import {
  Form,
  //Input,
  FormItem,
  DatePicker,
  //Divider,
  //InputNumber,
  Select,
  //OptionGroup,
  Option,
  Button,
  //Notification
  //Checkbox,
  //RadioGroup,
  //Radio
} from "element-ui";

export default {
  components: {
    Form,
    //Input,
    FormItem,
    DatePicker,
    //Divider,
    //InputNumber,
    Select,
    //OptionGroup,
    Option,
    Button,
  },
  data() {
    return {
      srch: {
        courseId: null,
        id: null,
        p2: "",
        startDate: null,
        endDate: null,
      },
      coreSearchModel: {},
      filterData: {
        tasks: [],
      },
    };
  },
  methods: {
    ...mapActions(["handleLoading"]),
  },
  mounted() {
    let _pid = 0;
    let proj = this.$store.state.app.groupDefaultProjects.filter(
      (x) => x.objectTypeId == 115
    );
    if (proj.length) {
      _pid = proj[0].id;
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          projectId: _pid,
          skip: 0,
          size: 2000,
          id: 0,
          model: this.coreSearchModel,
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res.data.tasks.length > 0) {
          this.filterData.tasks = _.orderBy(res.data.tasks, ["id"], ["desc"]);

          if (this.$store.state.app.mainReportData.show) {
            if (
              this.$store.state.app.mainReportData.propObj.loginName !=
                undefined &&
              this.$store.state.app.mainReportData.propObj.loginName != null
            )
              this.srch.userId = this.$store.state.app.mainReportData.propObj.loginName;

            if (
              this.$store.state.app.mainReportData.propObj.courseId !=
                undefined &&
              this.$store.state.app.mainReportData.propObj.courseId != null
            ) {
              this.srch.id = this.$store.state.app.mainReportData.propObj.courseId;
              this.$emit("on-seach", this.srch);
            }
          }
        } else
          this.filterData.tasks = [
            { id: 0, task: "Байгууллагын админд хандана уу" },
          ];
      });
    }
  },
};
</script>
